import { useMemo } from "react";

const useJarsToMintByBearsCount = (bearsCount?: number): number | undefined =>
  useMemo(() => {
    if (bearsCount !== undefined && Number.isInteger(bearsCount)) {
      if (bearsCount < 1) {
        return 0;
      }

      return bearsCount >= 5 ? bearsCount * 2 : bearsCount * 2 - 1;
    }
  }, [bearsCount]);

export default useJarsToMintByBearsCount;
